import { render, staticRenderFns } from "./MonthlySSBSubmissionRecordNew.vue?vue&type=template&id=de0a422a"
import script from "./MonthlySSBSubmissionRecordNew.vue?vue&type=script&lang=js"
export * from "./MonthlySSBSubmissionRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports